import AparmentDetail from '../../features/admin/AparmentDetail'

const AparmentDetailPage = () => {

    
    return (
        <AparmentDetail />
    )
}

export default AparmentDetailPage